<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDictColumnList',
})
</script>
<template>
	<el-table-column
		:prop="prop"
		:label="label"
		:header-align="headerAlign"
		:align="align"
		:width="width"
		:min-width="minWidth"
		:class-name="className"
	>
		<template #default="scope">
			<ma-dict-label v-for="item in befLabel(scope.row[props.prop])" :key="item" :dict-type="props.dictType" :dict-value="item" />
		</template>
	</el-table-column>
</template>

<script setup lang="ts" name="MaDictColumnList">
import { computed } from 'vue'
const props = defineProps({
	prop: {
		type: String,
		required: true
	},
	label: {
		type: String,
		required: true
	},
	dictType: {
		type: String,
		required: true
	},
	headerAlign: {
		type: String,
		required: false,
		default: () => 'left'
	},
	align: {
		type: String,
		required: false,
		default: () => 'left'
	},
	width: {
		type: String,
		required: false,
		default: () => ''
	},
	minWidth: {
		type: String,
		required: false,
		default: () => ''
	},
	className: {
		type: String,
		required: false,
		default: () => 'primary'
	},
	split: {
		type: String,
		required: false,
		default: ','
	}
})

const befLabel = (str: string) => {
	try {
		return str.split(props.split)
	} catch (error) {
		return []
	}
}
</script>
